import HDR from 'constants/httpHeader.const';
import { NO_MEDIA_TYPE } from 'constants/misc.const';

const determineConfig = (options) => {
  const result = {
    method: 'GET',
    ...(options?.api?.config ?? {}),
    headers: {
      [HDR.ct]: 'application/json',
      ...(options?.api?.config?.headers ?? {}),
      [HDR.lt]: options?.state?.lib?.lockToken,
    },
  };

  // NOTE: options explicitly require no default content type set by this
  if (NO_MEDIA_TYPE === result.headers?.[HDR.ct]) delete result.headers[HDR.ct];

  return result;
};

export default determineConfig;
